module.exports = __webpack_public_path__ + "img/logo-base.3156e47f.png";